const renderSoldLabel = sold => {
  if (sold) {
    return <span className='sold'>&nbsp; - SOLD</span>;
  }
};

export default renderSoldLabel;
